module.exports = "<app-header></app-header>\n<div class=\"page-margin\">\n  <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n"